import { compose, composeU } from '@bem-react/core';
import { withRegistry, Registry } from '@bem-react/di';
// Registry dependencies
import { Icon, withGlyphTypeCross, } from '@yandex-lego/components/Icon/desktop';
import { withTypeError as IconWithTypeError, } from '../../Icon/_type/Icon_type_error';
import { withTypeWarning as IconWithTypeWarning, } from '../../Icon/_type/Icon_type_warning';
import { withTypeInfo as IconWithTypeInfo, } from '../../Icon/_type/Icon_type_info';
// base
import { MessageBar as MessageBarDesktop, cnMessageBar, } from '../MessageBar@desktop';
// size
import { withSizeS } from '../_size/MessageBar_size_s';
import { withSizeM } from '../_size/MessageBar_size_m';
// type
import { withTypeError } from '../_type/MessageBar_type_error';
import { withTypeInfo } from '../_type/MessageBar_type_info';
import { withTypeWarning } from '../_type/MessageBar_type_warning';
// pin
import { withPinBrickBrick } from '../_pin/MessageBar_pin_brick-brick';
export * from '../MessageBar@desktop';
var registry = new Registry({ id: cnMessageBar() })
    .set('Icon', compose(composeU(IconWithTypeError, IconWithTypeWarning, IconWithTypeInfo), withGlyphTypeCross)(Icon));
export var MessageBar = compose(withPinBrickBrick, composeU(withTypeError, withTypeInfo, withTypeWarning), composeU(withSizeS, withSizeM), withRegistry(registry))(MessageBarDesktop);
